export default __webpack_public_path__ + "static/media/132124982_408631463711168_4291026378939747999_n.11eddfd5.jpg";